import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            精选专题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">精心策划的影视专题，发现你的心动之选</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardsData.map((card) => (
              <a
                key={card.id}
                href="#cards"
                className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[3/2] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="600"
                    height="400"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block text-[10px] font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full mb-2">
                    {card.category}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}